import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgIoCloudUploadOutline({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.45208 6.57801C6.35631 4.34881 8.62119 2.24017 12 2.24017C15.6352 2.24017 18.7335 4.71357 19.4128 8.71618C20.3719 8.85975 21.3762 9.22709 22.2031 9.84135C23.2309 10.6048 24 11.7681 24 13.3214C24 14.8275 23.3659 16.0257 22.3336 16.8288C21.3217 17.6161 19.9749 17.9902 18.5625 17.9902H15C14.5858 17.9902 14.25 17.6544 14.25 17.2402C14.25 16.826 14.5858 16.4902 15 16.4902H18.5625C19.7283 16.4902 20.7252 16.1796 21.4125 15.6449C22.0794 15.1261 22.5 14.3649 22.5 13.3214C22.5 12.3252 22.0269 11.5791 21.3086 11.0455C20.5718 10.4982 19.5953 10.1955 18.7129 10.1518C18.3434 10.1335 18.0425 9.84853 18.0041 9.48063C17.6262 5.86521 15.0277 3.74017 12 3.74017C9.14101 3.74017 7.31311 5.62624 6.71419 7.49417C6.62259 7.77983 6.36958 7.98344 6.07093 8.01181C3.48645 8.25734 1.5 9.84844 1.5 12.2527C1.5 14.6697 3.58853 16.4902 6.375 16.4902H9C9.41421 16.4902 9.75 16.826 9.75 17.2402C9.75 17.6544 9.41421 17.9902 9 17.9902H6.375C2.97397 17.9902 0 15.6969 0 12.2527C0 8.97706 2.59336 7.02009 5.45208 6.57801Z"
				fill={finalColor}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.4697 8.45983C11.7626 8.16693 12.2374 8.16693 12.5303 8.45983L15.5303 11.4598C15.8232 11.7527 15.8232 12.2276 15.5303 12.5205C15.2374 12.8134 14.7626 12.8134 14.4697 12.5205L12.75 10.8008V21.0098C12.75 21.4241 12.4142 21.7598 12 21.7598C11.5858 21.7598 11.25 21.4241 11.25 21.0098V10.8008L9.53033 12.5205C9.23744 12.8134 8.76256 12.8134 8.46967 12.5205C8.17678 12.2276 8.17678 11.7527 8.46967 11.4598L11.4697 8.45983Z"
				fill={finalColor}
			/>
		</svg>
	);
}
export default SvgIoCloudUploadOutline;
